module.exports = __webpack_public_path__ + "img/tickets-r3-req--network-security-internet.861a7aa5.png";